import axios from '@/axios'
import Vue from 'vue'

const state = {
  banners: [],
};

const actions = {
  fetchBanners({ commit }) {
    axios.get('banners')
      .then(r => commit('SET_BANNERS', r.data.banners));
  }
};
const mutations = {
  SET_BANNERS(state, banners) {
    Vue.set(state, 'banners', banners);
  }
};

export default {
  state,
  actions,
  mutations
}
